import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getListWithAuthenticated,
  postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const AddUpdateSource = `${Base_Url}/Source`;

export const AddUpdateSourecApi = async (url, params) => {
  const res = await postApiWithAuthenticated(
    `${AddUpdateSource}${url}`,
    params
  );
  return res;
};

export const GetSourecDataList = async (params) => {
  const url = `${AddUpdateSource}/GetSourceList`;
  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const GetSourecModel = async (id) => {
  let url = `${AddUpdateSource}/GetSourceModel?SourceKeyID=${id}`;

  const res = await getListWithAuthenticated(url);
  return res;
};

export const ChangeStatusSourceApi = async (sourceKeyID, userKeyID) => {
  let url = `${AddUpdateSource}/ChangeSourceStatus?SourceKeyID=${sourceKeyID}&UserKeyID=${userKeyID}`;

  const res = await getListWithAuthenticated(url);
  return res;
};
